module.exports = __webpack_public_path__ + "static/img/female-bg-es.0596c88e.png";